module.exports = __webpack_public_path__ + "static/headshot2-83810518e0a4dfb1edb593f4e6762a25.jpg";